module.exports = __webpack_public_path__ + "img/madonna_madamex.71919a3a.jpg";